<template lang="pug">
    div
        v-dialog.dialogEdit(v-model="show"
            width="680")
            v-card.dialogEdit
                v-card-text.pb-0
                v-container
                    div.gr-loader-snipper--wrapper(v-if="loading")
                        span.gr-loader-snipper
                    skeleton-card(v-if="loading")
                    v-row#headerModalEdit.pt-3(v-if="!loading")
                        v-col(cols="10")
                            span(v-if="!isAdverbia") #[translate Videos del restaurante]
                            span(v-else) Videos del negocio
                        v-col.mt-5(cols="2")
                            img.close-modal.cursor-pointer(:src="imgClose" @click.stop="show=false")
                    v-row#bodyModalEdit(v-if="!loading")
                        v-col(cols="12")
                            v-container
                                v-row
                                    Errors(v-if="errors" :errors="errors")
                                    v-col.text-left.pt-6.pb-4(cols="12" v-if="!saveStatus")
                                        div.messageError
                                            span {{ messageError ? messageError : $gettext('An error occurred while recording.') }}                                                                      
                                    v-col.text-left.pb-0(cols="8")
                                        p
                                            span #[translate Los requisitos del video son los siguientes:]
                                            br
                                            span #[translate Resolución: 720p o superior]
                                            br
                                            span #[translate Peso: máximo 75 MB]
                                            br
                                            span #[translate Duración: máximo 30 segundos]
                                    v-col.pb-0(cols="4")
                                    v-col.text-left(cols="12")                                    
                                        v-row                                        
                                            v-col(md="6")                                                
                                                v-file-input.addPhoto.d-flex.flex-column.align-center.justify-center.py-8(
                                                    :rules="rules"
                                                    v-model="image"
                                                    id="file" ref="file"
                                                    :placeholder="placeholderAddPhoto"
                                                    prepend-icon="mdi-camera"
                                                    label="")
                                            v-col(md="6")
                                                
                                                
                        v-col.boxThumbnails(cols="12")
                            v-container
                                v-row
                                    v-col.text-left(cols="12")                                    
                                        v-row                                        
                                            v-col(md="2" v-for="(video, index) in data.googlevideos")
                                                .photo
                                                    div.boxPhoto
                                                        img(:src="video.video_thumbnail_url")
                                                    div.text-center.removePhoto
                                                        img(:src="imgtrash" @click="removePhoto(index)")
                    v-row#footerModalEdit
                        v-col(cols="12")
                            button.btnCancelEditModal(@click.stop="show=false") #[translate Cancel]
                            button.btnSaveEditModal(@click="save()")  #[translate Save]
</template>
<script>
import commonMixins from '@/mixins/common.js'
import SrvLocal from '@/services/local.js'
import SkeletonCard from '@/components/common/skeletonCard.vue'
import Errors from '@/components/common/Errors.vue'

export default {
    mixins: [commonMixins],
    components: { SkeletonCard, Errors },
    props: ['visible', 'idBussines'],
    data(){
        return {
            loading: false,
            imgClose: require('@/assets/img/ico-close-edit.svg'),
            imgtrash: require('@/assets/img/ico-trash.svg'),
            url: null,
            image: null,
            data: {},
            videosChanged: false,
            categorieVideo: {name: "Otras", video_type: "ADDITIONAL"},
            section: 'videos-restaurant',
            rules: [
                value => !value || value.size < 75000000 || this.$gettext('Avatar size should be less than 5 MB!'),
            ],
            file: '',
            saveStatus: true,
            messageError: null,
            errors: null
        }
    },
    watch: {
        visible (newValue){
            if (newValue) {
                this.data = {}
                this.loadData()
            }
        }
    },
    computed: {
        placeholderAddPhoto () {
            return this.$gettext('Añadir video')
        },
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                this.$emit('close')
                }
            }
        }
    },
    methods: {
        handleFileUpload(){
            this.file = this.$refs.file.input.files[0];
        },
        removePhoto (key) {
            this.data.googlevideos.splice(key,1)
            this.videosChanged = true
        },
        async loadData () {
            this.loading = true           
            const res = await SrvLocal.getLocalMarketing(this.section)
            if (res.status === 200) {
                this.data = res.data
                this.loading = false
            } 
        },
        async save () {
            // IDS
            this.loading = true         
            if (this.videosChanged) {
                let ids = {googlevideos:[]}
                this.data.googlevideos.forEach(element => {
                    ids.googlevideos.push(element.id)
                })
                const res = await SrvLocal.setLocalMarketing(this.section, ids)
                if (res.status !== 200) {
                    this.saveStatus = false     
                }                 
            }

            if (this.image) {   
                let valid = true
                try {  
                    if (valid) {   
                        
                        try {
                            const res = await SrvLocal.uploadLocalMarketingVideo(this.idBussines, this.image, this.categorieVideo.video_type)
                            if (res.status !== 200) {
                                this.saveStatus = false 
                            }
                            if (this.saveStatus) {
                                this.image = ''
                                this.url = ''
                            } 
                            
                        } catch (e) {
                            this.errors = e.response.data.error === 'Problem creating video' ? 'Ha ocurrido un problema al subir el video' : e.response.data.error
                        }
                    }
                } catch(e) {
                    this.loading = false
                }               
            }

            if (this.saveStatus) {
                const res = await SrvLocal.syncBunsinessVideos(this.idBussines)
                if (Object.keys(res.data).includes('success') && !res.data.success) {
                    this.saveStatus = false
                    this.messageError = res.data.error.message
                } else {
                    this.show = false
                    this.$emit('refreshSync')
                }
            }
            
            this.loading = false
        }
    }
}
</script>
<style lang="scss" scoped>
    .boxThumbnails{
        border-top:1px solid #000;
    }
    .addPhoto{
        border: 2px solid #00ADFC;
        max-height: 153px;
        color: #00ADFC;
    }
    .preview{
        height: 73px;
    }
    .titleSelectCategory{
        font-weight: 600;
    }
    .boxPhoto{
        height: 65px;
        overflow: hidden;
    }
    .removePhoto{
        img{
            cursor:pointer;
        }
    }
    .messageError{
        background-color: #F5B1B8;
        border: 1px solid #F93549;
        color: #F93549;
        padding:15px;
    }
</style>